import {
  FileAudioIcon,
  FileCIcon,
  FileCodeIcon,
  FileCSharpIcon,
  FileCssIcon,
  FileCsvIcon,
  FileDocIcon,
  FileHtmlIcon,
  type Icon,
  FileIcon,
  FileImageIcon,
  FileIniIcon,
  FileJpgIcon,
  FileJsIcon,
  FileJsxIcon,
  FileLockIcon,
  FileMdIcon,
  FilePdfIcon,
  FilePngIcon,
  FilePptIcon,
  FilePyIcon,
  FileRsIcon,
  FileSqlIcon,
  FileSvgIcon,
  FileTsIcon,
  FileTsxIcon,
  FileTxtIcon,
  FileVideoIcon,
  FileVueIcon,
  FileXlsIcon,
  FileZipIcon,
} from '@phosphor-icons/react';

const EXTENSION_ICONS: Record<string, Icon> = {
  ts: FileTsIcon,
  tsx: FileTsxIcon,
  js: FileJsIcon,
  mjs: FileJsIcon,
  cjs: FileJsIcon,
  jsx: FileJsxIcon,
  json: FileCodeIcon,
  yaml: FileCodeIcon,
  yml: FileCodeIcon,
  toml: FileCodeIcon,
  css: FileCssIcon,
  html: FileHtmlIcon,
  htm: FileHtmlIcon,
  md: FileMdIcon,
  mdx: FileMdIcon,
  txt: FileTxtIcon,
  py: FilePyIcon,
  rs: FileRsIcon,
  c: FileCIcon,
  cpp: FileCodeIcon,
  cc: FileCodeIcon,
  h: FileCodeIcon,
  hpp: FileCodeIcon,
  cs: FileCSharpIcon,
  vue: FileVueIcon,
  sql: FileSqlIcon,
  csv: FileCsvIcon,
  doc: FileDocIcon,
  docx: FileDocIcon,
  pdf: FilePdfIcon,
  ppt: FilePptIcon,
  pptx: FilePptIcon,
  xls: FileXlsIcon,
  xlsx: FileXlsIcon,
  zip: FileZipIcon,
  tar: FileZipIcon,
  gz: FileZipIcon,
  rar: FileZipIcon,
  png: FilePngIcon,
  jpg: FileJpgIcon,
  jpeg: FileJpgIcon,
  svg: FileSvgIcon,
  gif: FileImageIcon,
  webp: FileImageIcon,
  bmp: FileImageIcon,
  mp3: FileAudioIcon,
  wav: FileAudioIcon,
  ogg: FileAudioIcon,
  mp4: FileVideoIcon,
  mov: FileVideoIcon,
  webm: FileVideoIcon,
  ini: FileIniIcon,
  env: FileIniIcon,
  conf: FileIniIcon,
  cfg: FileIniIcon,
  lock: FileLockIcon,
};

export function getFileIcon(name: string): Icon {
  const ext = name.split('.').pop()?.toLowerCase();
  return (ext && EXTENSION_ICONS[ext]) || FileIcon;
}
